import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment';

@Injectable({
  providedIn: 'root'
})
export class EcadashboardService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

    addTutor($data: any) {
        return this.http.post(checkUrl()+"/ecademic/admin/addTutor",$data)
        .pipe((response)=>{
            return response;
        });
    }

    addSubAdmin($data: any) {
        return this.http.post(checkUrl()+"/ecademic/admin/addSubmin",$data)
        .pipe((response)=>{
            return response;
        });
    }

    addSession($data: any) {
      console.log("RUN");
        return this.http.post(checkUrl()+"/ecademic/session/add",$data)
        .pipe((response)=>{
            return response;
        });
    }

    adminDashboard(){
        return this.http.get(checkUrl()+"/ecademic/admin/dashboard").pipe((response)=>{
          return response;
        });
    }

    userList($data:any){
        return this.http.post(checkUrl()+"/ecademic/admin/list",$data)
        .pipe((response)=>{
          return response;
        });
    }

}


